

export const CONFIG = {
  REACT_APP_ENDPOINT: "",
  REACT_APP_UPLOADS:  "/uploads",
};

// export const CONFIG = {
//   REACT_APP_ENDPOINT: "http://localhost:5050",
//   REACT_APP_UPLOADS: "http://localhost:5050/uploads"
// }